import { useEffect, useState } from "react";

import DashboardTemplate from "../../../templates/Dashboard";
import {
  Avatar,
  Breadcrumb,
  Button,
  Card,
  Col,
  Flex,
  Progress,
  Row,
  Switch,
  Tabs,
  TabsProps,
  Tag,
} from "antd";
import {
  AngleRight,
  ArrowRightIcon,
  ContractsIcon,
  NeedHelp,
} from "../../../atoms/CustomIcons";
import WorkReports from "./Tabs/WorkReports";
import WorkDetails from "./Tabs/WorkDetails";
import Materials from "./Tabs/Materials";
import Equipment from "./Tabs/Equipment";
import TimerIcon from "../../../atoms/CustomIcons/TimerIcon";
import JobCosting from "./Tabs/JobCosting";
import woDetail from "../DummyData/woDetail.json";
import {
  getWorkOrderDetails,
  removeWorkOrderDetailData,
} from "../ducks/actions";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import dayjs from "dayjs";
import { formatEstimatedHrs, getCompanyInitials } from "../../../config/utils";

// interface FormValues {
//   choose_visit: string[];
// }

export default function WorkOrderReport() {
  const [loading] = useState(false);
  const dispatch = useAppDispatch();

  const [totalVisit, setTotalVisit] = useState(0);

  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const workOrderID = pathSegments[pathSegments.length - 2];

  const woDetailData = useAppSelector(
    (state) => state?.workOrders?.woDetailData
  );

  // const { control } = useForm<FormValues>();
  // const dummyOptions = [
  //   { label: "All visits", value: "All visits" },
  //   { label: "Visit 1", value: "1" },
  //   { label: "Visit 2", value: "2" },
  //   { label: "Visit 3", value: "3" },
  // ];

  // const statusColors = {
  //   OPEN: "#98A3A9",
  //   SCHEDULED: "#E6C300",
  //   CONFIRMATION_PENDING: "#6454F4",
  //   APPROVAL_PENDING: "#943AF5",
  //   COMPLETED: "#00A07D",
  //   CANCELED: "#CD1951",
  //   CLOSED: "#F06400",
  // };

  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Work reports",
      children: <WorkReports />,
    },
    {
      key: "2",
      label: "Work details",
      children: (
        <WorkDetails woDetailData={woDetailData?.data} companyId={companyId} />
      ),
    },
    {
      key: "3",
      label: "Materials",
      children: <Materials woDetailData={woDetailData?.data} />,
    },
    {
      key: "4",
      label: "Equipment",
      children: <Equipment woDetailData={woDetailData?.data} />,
    },
    {
      key: "5",
      label: "Job costing",
      children: <JobCosting woDetailData={woDetailData?.data} />,
    },
  ];

  // const items = [
  //   {
  //     key: "1",
  //     label: (
  //       <Button
  //         type="text"
  //         className="no-hover"
  //         onClick={(e) => {
  //           e.stopPropagation();
  //         }}
  //         icon={<ImageRemoveIcon />}
  //       >
  //         Doesn’t require picture after
  //       </Button>
  //     ),
  //   },
  //   {
  //     key: "2",
  //     label: (
  //       <Button
  //         type="text"
  //         className="no-hover"
  //         onClick={(e) => {
  //           e.stopPropagation();
  //         }}
  //         icon={<ImageAddIcon />}
  //       >
  //         Requires picture after
  //       </Button>
  //     ),
  //   },
  // ];

  useEffect(() => {
    dispatch(removeWorkOrderDetailData());
  }, [dispatch]);

  useEffect(() => {
    if (workOrderID) {
      dispatch(getWorkOrderDetails(workOrderID));
    }
  }, [dispatch, workOrderID]);

  useEffect(() => {
    if (woDetailData?.data) {
      setTotalVisit(Math.round(woDetailData.data.total_no_of_visits));
    }
  }, [woDetailData]);

  return (
    <DashboardTemplate loading={loading || woDetailData?.loader}>
      <div
        style={{
          padding: "8px",
          backgroundColor: "#6454F4",
          borderRadius: "12px",
          marginBottom: "12px",
          position: "relative",
          zIndex: "99",
        }}
      >
        <p
          style={{
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "24px",
            color: "#FFFFFF",
            marginBottom: "0px",
            textAlign: "center",
          }}
        >
          Work order details contain demo data for illustration purposes.
        </p>
      </div>
      <div className="forBackground">
        <Row gutter={[8, 8]} wrap={false}>
          <Col
            flex="450px"
            className="weeklyService"
            style={{ paddingRight: "0px !important" }}
          >
            <Card>
              <Breadcrumb
                separator={<AngleRight />}
                style={{ marginBottom: "16px" }}
              >
                <Breadcrumb.Item>
                  <a href={`/work-orders/${companyId}`}> Work Orders </a>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{woDetailData?.data?.name}</Breadcrumb.Item>
              </Breadcrumb>

              <div className="weeklyServiceWidget">
                {woDetailData?.data?.image_url ? (
                  <img src={woDetailData?.data?.image_url} alt="" />
                ) : (
                  // <Avatar shape="square" />
                  <img src="/images/company/no_image_grey.png" alt="" />
                )}
                <div
                  className={
                    totalVisit > 1 ? "overlay" : "overlay noVisitOverlay"
                  }
                >
                  {totalVisit > 1 && (
                    <div className="progress">
                      <Progress
                        type="dashboard"
                        percent={
                          ((woDetailData?.data?.scheduled_no_of_visits ?? 0) /
                            totalVisit) *
                          100
                        }
                        steps={totalVisit}
                        trailColor="#007F61"
                        strokeWidth={5}
                        strokeColor="#6AD3B7"
                        format={() => (
                          <>
                            <div
                              style={{
                                fontSize: 16,
                                fontWeight: "700",
                                color: "#fff",
                                marginBottom: 7,
                              }}
                            >
                              <span style={{ color: "#6AD3B7" }}>
                                {woDetailData?.data?.scheduled_no_of_visits ??
                                  0}
                              </span>
                              / {totalVisit}
                            </div>
                            <div
                              style={{
                                fontSize: 13,
                                fontWeight: "600",
                                color: "#fff",
                              }}
                            >
                              visits
                            </div>
                          </>
                        )}
                      />
                    </div>
                  )}

                  <div className="progressDetail">
                    <h3>{woDetailData?.data?.name}</h3>
                    <h6>{woDetailData?.data?.service_line_name}</h6>
                    <div>
                      <Tag
                        className="dark_purple_tag"
                        style={{ textTransform: "capitalize" }}
                      >
                        {woDetailData?.data?.status?.toLowerCase()}
                      </Tag>
                    </div>
                  </div>

                  <img
                    src="/images/work-orders/work_order_badge.svg"
                    alt=""
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "0px",
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                    }}
                  />
                </div>
              </div>

              {/* <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <h6
                  style={{
                    marginBottom: "0px",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "700",
                  }}
                >
                  Choose visit
                </h6>

                <SelectField
                  fieldName="choose_visit"
                  control={control}
                  selectOption={dummyOptions}
                  defaultValue={["All visits"]}
                  iProps={{
                    placeholder: "Choose visit",
                    mode: "multiple",
                  }}
                  className="fullWidthField"
                />

                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  className="actionButton"
                  placement="bottomRight"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "10px",
                      height: "36px",
                      width: "36px",
                      border: "1px solid #DEE5E6",
                      backgroundColor: "transparent",
                      borderRadius: "10px",
                    }}
                    className="status_dropdown"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              </div> */}

              <div className="overallSummary">
                <Card style={{ borderRadius: "12px", marginBottom: "8px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "8px",
                    }}
                  >
                    <h4> Assignee </h4>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {woDetailData?.data?.crew_leader_image_url && (
                        <img
                          src={woDetailData?.data?.crew_leader_image_url}
                          alt=""
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "6px",
                          }}
                        />
                      )}
                      <h4
                        style={{
                          fontSize: "12px",
                          lineHeight: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {woDetailData?.data?.crew_or_contractor_name ?? ""}
                        {woDetailData?.data?.crew_leader_name ?? ""}
                      </h4>
                    </div>
                  </div>
                </Card>
                <Card style={{ borderRadius: "12px", marginBottom: "8px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "12px",
                    }}
                  >
                    <h4> Labor hours </h4>
                    <Button htmlType="button" className="outlined-btn btn-sm">
                      <TimerIcon /> Timesheets
                    </Button>
                  </div>
                  <Flex gap="small" vertical className="LabourProgressBar">
                    {(() => {
                      const estimated = woDetailData?.data?.estimated_hrs ?? 0;
                      const actual = woDetailData?.data?.actual_hrs ?? 0;
                      const totalVisits =
                        woDetailData?.data?.total_no_of_visits ?? 0;

                      const hasEstimate = estimated > 0;

                      const savedPct = hasEstimate
                        ? Math.max(
                            0,
                            Math.min(
                              100,
                              Math.round(
                                ((estimated - actual) / estimated) * 100
                              )
                            )
                          )
                        : 0;

                      const totalEstimatedAllVisits =
                        hasEstimate && totalVisits > 0
                          ? estimated * totalVisits
                          : 0;

                      return (
                        <>
                          <Progress
                            percent={100}
                            success={{
                              percent: savedPct,
                              strokeColor: "#00A07D",
                            }}
                            strokeColor="#B2BDC2"
                            size={["100%", 32]}
                            style={{ borderRadius: "6px" }}
                          />

                          <div className="progressDetails">
                            <div className="mainBox">
                              <div className="leftTitle"> Actual </div>
                              <div className="rightTitle">
                                <span>
                                  {hasEstimate
                                    ? `${savedPct}% time saved`
                                    : "-"}
                                </span>{" "}
                                {actual ? formatEstimatedHrs(actual) : "-"}
                              </div>
                            </div>

                            <div className="mainBox">
                              <div className="leftTitle"> Estimated </div>
                              <div className="rightTitle">
                                {hasEstimate
                                  ? formatEstimatedHrs(estimated)
                                  : "0h"}{" "}
                              </div>
                            </div>
                            <div className="mainBox">
                              <div className="leftTitle">
                                Total estimated (all visits){" "}
                              </div>
                              <div className="rightTitle">
                                {totalEstimatedAllVisits
                                  ? formatEstimatedHrs(totalEstimatedAllVisits)
                                  : "0h"}
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </Flex>
                </Card>
                <Card style={{ borderRadius: "12px", marginBottom: "8px" }}>
                  <h4 style={{ marginBottom: "4px" }}> Requires approval </h4>
                  <div
                    className="switchBox"
                    style={{
                      fontWeight: "400",
                      justifyContent: "space-between",
                      marginBottom: "12px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "400",
                        color: "#6C7478",
                      }}
                    >
                      <span style={{ fontWeight: "600", color: "#6454F4" }}>
                        Branch manager{" "}
                      </span>
                      approves work order before it goes to billing
                    </div>
                    <Switch checked={woDetail.requiresApproval} />
                  </div>
                </Card>
                <Card style={{ borderRadius: "12px" }}>
                  <h4> Property </h4>
                  <table
                    className="propertyTable"
                    style={{
                      borderCollapse: "separate",
                      borderSpacing: "0 12px",
                    }}
                  >
                    <tr>
                      <td className="TableTitle"> Property </td>
                      <td className="TableDescription">
                        {woDetailData?.data?.property_name} <ArrowRightIcon />
                      </td>
                    </tr>
                    <tr>
                      <td className="TableTitle"> Contract </td>
                      <td className="TableDescription">
                        {woDetailData?.data?.contract_name} <ArrowRightIcon />
                      </td>
                    </tr>

                    <tr>
                      <td className="TableTitle"> Contract dates </td>
                      <td className="TableDescription">
                        {dayjs(woDetailData?.data?.start_date).format("ll")} -{" "}
                        {dayjs(woDetailData?.data?.end_date).format("ll")}
                      </td>
                    </tr>
                    <tr>
                      <td className="TableTitle"> Production manager </td>
                      <td className="TableDescription">
                        {woDetailData?.data?.production_manager_name && (
                          <div className="tableImage">
                            {woDetailData?.data
                              ?.production_manager_image_url ? (
                              <img
                                src={
                                  woDetailData.data
                                    ?.production_manager_image_url
                                }
                                alt=""
                                style={{
                                  borderRadius: "100px",
                                  width: "22px",
                                  height: "22px",
                                }}
                              />
                            ) : (
                              <Avatar
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "16px",
                                  fontWeight: "500",
                                  width: "22px",
                                  height: "22px",
                                }}
                              >
                                {getCompanyInitials(
                                  woDetailData?.data?.production_manager_name
                                )}
                              </Avatar>
                            )}
                            {woDetailData?.data?.production_manager_name}
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="TableTitle"> Account manager </td>
                      <td className="TableDescription">
                        {woDetailData?.data?.account_manager_name && (
                          <div className="tableImage">
                            {woDetailData?.data?.account_manager_image_url ? (
                              <img
                                src={
                                  woDetailData?.data?.account_manager_image_url
                                }
                                alt=""
                                style={{ borderRadius: "100px" }}
                              />
                            ) : (
                              <Avatar
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "16px",
                                  fontWeight: "500",
                                  width: "22px",
                                  height: "22px",
                                }}
                              >
                                {getCompanyInitials(
                                  woDetailData?.data?.account_manager_name
                                )}
                              </Avatar>
                            )}
                            {woDetailData?.data?.account_manager_name}
                          </div>
                        )}
                      </td>
                    </tr>
                  </table>
                </Card>
              </div>
            </Card>
          </Col>
          <Col
            flex="auto"
            className="serviceDetails"
            style={{ paddingLeft: "0px !important" }}
          >
            <Card>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "0px",
                }}
              >
                <Button className="btn-sm" disabled={true}>
                  <NeedHelp /> Need help?
                </Button>

                <Button
                  icon={<ContractsIcon />}
                  className="outlined-btn"
                  disabled={true}
                >
                  Activity history
                </Button>
              </div>
              <div>
                <h2 style={{ marginBottom: "16px" }}> Service details </h2>
                <Tabs
                  defaultActiveKey="1"
                  items={tabItems}
                  className="workOrderTabs"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </DashboardTemplate>
  );
}
